import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { worldCupBreakingEventsDataProvider } from './dataProvider';

export function initWorldCupBreakingEventsDataProvider() {
  registerModuleDataProvider(Resources.worldCupBreakingEvents, worldCupBreakingEventsDataProvider);
  registerModuleDataProvider(Resources.worldCupBreakingEventsEvents, worldCupBreakingEventsDataProvider);
}

initWorldCupBreakingEventsDataProvider();
